export const success = {
  save: 'Registro salvo com sucesso',
  update: 'Registro alterado com sucesso',
  delete: 'Registro excluído com sucesso',
  sendEmail: 'E-mail enviado com sucesso!',
  resetPassword: 'Senha redefinida com sucesso',
  updateTable: 'Tabela atualizada com sucesso',
  user: {
    changePassword: 'Senha alterada com sucesso',
  }
};
